export default {
  data() {
    return {
      screenSize: 0,
      isMobile: false,
      isTablet: false,
      isDesktop: false,
      isDesktopLarge: false,
    }
  },

  methods: {
    updateWindowSize() {
      this.screenSize = window.innerWidth
      this.isMobile = this.screenSize < 768
      this.isTablet = this.screenSize >= 768 && this.screenSize < 1024
      this.isDesktop =
        this.screenSize >= 1024 && this.screenSize < 1440
      this.isDesktopLarge = this.screenSize >= 1440
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.updateWindowSize()
    })
    window.addEventListener('resize', this.updateWindowSize)
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.updateWindowSize)
  },
}
